"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var deferred_1 = require("./deferred");
var CANCEL_OP = {};
function isCancel(maybeCancelOp) {
    return maybeCancelOp === CANCEL_OP;
}
exports.isCancel = isCancel;
function createCancelTokenSource() {
    var deferred = new deferred_1.default();
    return {
        cancel: function () { return deferred.resolve(CANCEL_OP); },
        token: {
            promise: deferred.promise,
        },
    };
}
exports.createCancelTokenSource = createCancelTokenSource;
//# sourceMappingURL=cancel-token.js.map